<script>

  import signoutMixin from '../mixins/signoutMixin'

  export default {
    mixins: [signoutMixin],
    created () {
      window.AppData.app.external = true;
    }
  }
  
</script>


// WEBPACK FOOTER //
// src/components/ExternalRedirect.vue